import { AxiosRequestConfig, AxiosResponse } from "axios";
import { baseService } from "../axiosServices";

// Set a default value for the config parameter
const getStatusInfo = async (config: AxiosRequestConfig = {}): Promise<AxiosResponse<any>> => {
    return await baseService.get("/status", config);
}

export { getStatusInfo };
